import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Notification {
  id: string
  type: 'success' | 'error' | 'warning' | 'info'
  title: string
  message: string
  duration?: number
}

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notification[]>([])

  const showSuccess = (message: string, title = 'Sucesso', duration = 3000) => {
    addNotification({
      type: 'success',
      title,
      message,
      duration
    })
  }

  const showError = (message: string, title = 'Erro', duration = 5000) => {
    addNotification({
      type: 'error',
      title,
      message,
      duration
    })
  }

  const showWarning = (message: string, title = 'Atenção', duration = 4000) => {
    addNotification({
      type: 'warning',
      title,
      message,
      duration
    })
  }

  const showInfo = (message: string, title = 'Informação', duration = 3000) => {
    addNotification({
      type: 'info',
      title,
      message,
      duration
    })
  }

  const addNotification = (notification: Omit<Notification, 'id'>) => {
    const id = Date.now().toString()
    const newNotification: Notification = {
      id,
      ...notification
    }

    notifications.value.push(newNotification)

    // Auto remove após duration
    if (notification.duration && notification.duration > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, notification.duration)
    }
  }

  const removeNotification = (id: string) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const clearAll = () => {
    notifications.value = []
  }

  return {
    notifications,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    addNotification,
    removeNotification,
    clearAll
  }
})
